import * as types from '../constants/oemConstants';

const initialState = {
  partners: [],
  partnerNames: [],
  partnerUsers: [],
  scanTypes: [],
  loading: false,
  formLoading: false,
  scanTypesLoading: false,
  partnerNamesLoading: false,
  partnerUsersLoading: false,
  error: null,
  success: false,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
  usersPagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10,
  },
};

const oemReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get OEM Partners
    case types.GET_OEM_PARTNERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_OEM_PARTNERS_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.response || action.payload.partners || [],
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.GET_OEM_PARTNERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        partners: [],
      };

    // Add OEM Partner
    case types.ADD_OEM_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        success: false,
        error: null,
      };
    case types.ADD_OEM_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        partners: action.payload.partners || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.ADD_OEM_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        success: false,
        error: action.payload,
      };

    // Edit OEM Partner
    case types.EDIT_OEM_PARTNER_REQUEST:
      return {
        ...state,
        formLoading: true,
        success: false,
        error: null,
      };
    case types.EDIT_OEM_PARTNER_SUCCESS:
      return {
        ...state,
        formLoading: false,
        success: true,
        partners: action.payload.partners || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.EDIT_OEM_PARTNER_FAILURE:
      return {
        ...state,
        formLoading: false,
        success: false,
        error: action.payload,
      };

    // Delete OEM Partner
    case types.DELETE_OEM_PARTNER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DELETE_OEM_PARTNER_SUCCESS:
      return {
        ...state,
        loading: false,
        partners: action.payload.partners || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.DELETE_OEM_PARTNER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Change OEM Status
    case types.CHANGE_OEM_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        statusChangeSuccess: false,
        error: null,
      };
    case types.CHANGE_OEM_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        statusChangeSuccess: true,
        partners: action.payload.partners || state.partners,
        pagination: action.payload.pagination || state.pagination,
        error: null,
      };
    case types.CHANGE_OEM_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        statusChangeSuccess: false,
        error: action.payload,
      };

    // Get Scan Types
    case types.GET_SCAN_TYPES_REQUEST:
      return {
        ...state,
        scanTypesLoading: true,
        error: null,
      };
    case types.GET_SCAN_TYPES_SUCCESS:
      return {
        ...state,
        scanTypesLoading: false,
        scanTypes: action.payload?.response || action.payload || [],
        error: null,
      };
    case types.GET_SCAN_TYPES_FAILURE:
      return {
        ...state,
        scanTypesLoading: false,
        error: action.payload,
        scanTypes: [],
      };

    // Get OEM Partner Names
    case types.GET_OEM_PARTNER_NAMES_REQUEST:
      return {
        ...state,
        partnerNamesLoading: true,
        error: null,
      };
    case types.GET_OEM_PARTNER_NAMES_SUCCESS:
      return {
        ...state,
        partnerNamesLoading: false,
        partnerNames: action.payload.response || action.payload || [],
        error: null,
      };
    case types.GET_OEM_PARTNER_NAMES_FAILURE:
      return {
        ...state,
        partnerNamesLoading: false,
        error: action.payload,
        partnerNames: [],
      };

    // Get OEM Partner Users
    case types.GET_OEM_PARTNER_USERS_REQUEST:
      return {
        ...state,
        partnerUsersLoading: true,
        error: null,
      };
    case types.GET_OEM_PARTNER_USERS_SUCCESS:
      return {
        ...state,
        partnerUsersLoading: false,
        partnerUsers: action.payload.response || action.payload || [],
        usersPagination: action.payload.pagination || state.usersPagination,
        error: null,
      };
    case types.GET_OEM_PARTNER_USERS_FAILURE:
      return {
        ...state,
        partnerUsersLoading: false,
        error: action.payload,
        partnerUsers: [],
      };

    default:
      return state;
  }
};

export default oemReducer;